import React, { Component } from 'react'

import Dico from '../../helpers/Dico'
import TextWithFieldname from '../texts/TextWithFieldname';
import ContDetailsButton from '../../containers/ContDetailsButton';
import HelperGenerics from '../../helpers/HelperGenerics';

class BottomTexts extends Component {

	render() {
		this.occRenvoiGlob = 1;
		const isResponseSimulation = this.props.responseSimulation != null;
		return (
			<div>
				{isResponseSimulation
					&& <div>
						{this.renderMultipleVehicleCases()}
						{this.props.process === 'options'
							&& this.props.responseSimulation.optionsRental != null
							&& this.props.responseSimulation.optionsRental.globalPrecision != null
							&& <TextWithFieldname fieldname="globalPrecision" developperView={this.props.developperView} variant="caption">
								* {this.props.responseSimulation.optionsRental.globalPrecision}
							</TextWithFieldname>
						}

						{this.props.process === 'accessories'
							&& this.props.responseSimulation.accessoriesIncrease != null
							&& this.props.responseSimulation.accessoriesIncrease.globalPrecision != null
							&& <TextWithFieldname fieldname="globalPrecision" developperView={this.props.developperView} variant="caption">
								* {this.props.responseSimulation.accessoriesIncrease.globalPrecision}
							</TextWithFieldname>
						}
						{this.renderSingleVehicleCases()}
					</div>}
			</div>
		)
	}

	renderMultipleVehicleCases() {
		const isResponseSimulation = this.props.responseSimulation != null;
		const isVehiclesRental = isResponseSimulation && this.props.responseSimulation.vehiclesRental != null;
		const isVehicleResults = isVehiclesRental && this.props.responseSimulation.vehiclesRental.vehicleResults != null;
		const isMultipleVehicles = this.props.process === 'vehiclesConfig' || this.props.process === 'vehiclesStock' || this.props.process === 'vehiclesDefault';

		return (<React.Fragment>
			{isMultipleVehicles && isVehicleResults
				&& <React.Fragment>
					{this.props.responseSimulation.vehiclesRental.vehicleResults.map((line, index) => (
						<React.Fragment key={index} >
							{line.teaser != null
								&& line.teaser.textConditions != null
								&& line.teaser.textConditions.regularPaymentConditions != null
								&& <TextWithFieldname fieldname="regularPaymentConditions" developperView={this.props.developperView} variant="caption" >
									{line.teaser.textConditions.regularPaymentConditions.map((line2, index2) => (
										<React.Fragment key={index2}>
											{this.renderReferenceOccurence(line2, index2, line.teaser)}
										</React.Fragment>
									))}
								</TextWithFieldname>
							}
						</React.Fragment >
					))}
					{this.props.responseSimulation.vehiclesRental.vehicleResults.map((line, index) => (
						<React.Fragment key={index} >
							{line.teaser != null
								&& line.teaser.textConditions != null
								&& line.teaser.textConditions.primaryTextConditions != null
								&& <TextWithFieldname fieldname="primaryTextConditions" developperView={this.props.developperView} variant="caption">
									{this.getRenderReferenceOccurenceMultipleLines(line.teaser.textConditions.primaryTextConditions, line)}
								</TextWithFieldname>
							}
						</React.Fragment >
					))}
					{this.props.responseSimulation.vehiclesRental.vehicleResults.map((line, index) => (
						<React.Fragment key={index} >
							{line.teaser != null
								&& line.teaser.textConditions != null
								&& line.teaser.textConditions.ctaTeaserConditions != null
								&& <TextWithFieldname fieldname="ctaTeaserConditions" developperView={this.props.developperView} variant="caption">
									{this.getRenderReferenceOccurenceMultipleLines(line.teaser.textConditions.ctaTeaserConditions, line)}
								</TextWithFieldname>
							}
						</React.Fragment >
					))}
				</React.Fragment>
			}
		</React.Fragment>);
	}

	renderSingleVehicleCases() {
		const isSingleVehicleBasketSummary = this.props.process === 'summary' || this.props.process === 'basket';
		const isSingleVehicleDetails = this.props.responseSimulation.vehicleDetails != null && this.props.responseSimulation.vehicleDetails.result != null;
		const isSingleVehicleTeaser = isSingleVehicleDetails && this.props.responseSimulation.vehicleDetails.result.teaser != null;
		const isSingleVehicleTextConditions = isSingleVehicleTeaser && this.props.responseSimulation.vehicleDetails.result.teaser.textConditions != null;

		return (<React.Fragment>
			{isSingleVehicleBasketSummary && isSingleVehicleDetails
				&& this.props.responseSimulation.vehicleDetails.result.globalText != null
				&& this.props.responseSimulation.vehicleDetails.result.globalText.bottomPageMention != null
				&& <TextWithFieldname fieldname="bottomPageMention" developperView={this.props.developperView} variant="caption">
					{this.props.responseSimulation.vehicleDetails.result.globalText.bottomPageMention.map((line, index) => (
						<span style={{ ...Dico.getStyle(line.style, true), fontSize: '10pt' }} key={index}>
							{Dico.getTextWithArguments(line,
								this.props.responseSimulation.vehicleDetails.result.teaser.data,
								this.props.amountNature, this.props.context.countryCode, this.props.context.languageCode,
								this.props.responseSimulation.vehicleDetails.result.teaser.guide)}
						</span>
					))}
				</TextWithFieldname>
			}
			{(this.props.process === 'summary' && this.props.context.renderType === 'STAMP')
				&& isSingleVehicleDetails
				&& this.props.responseSimulation.vehicleDetails.result.globalText != null
				&& this.props.responseSimulation.vehicleDetails.result.globalText.legalMention != null
				&& <TextWithFieldname fieldname="legalMention" developperView={this.props.developperView} variant="caption">
					{this.props.responseSimulation.vehicleDetails.result.globalText.legalMention.map(
						(line, index) => (
							<React.Fragment key={index}>
								{this.renderReferenceOccurence(line, index, this.props.responseSimulation.vehicleDetails.result.teaser)}
							</React.Fragment>
						))}
				</TextWithFieldname>
			}
			{isSingleVehicleBasketSummary && isSingleVehicleTextConditions
				&& this.props.responseSimulation.vehicleDetails.result.teaser.textConditions.regularPaymentConditions != null
				&& <TextWithFieldname fieldname="regularPaymentConditions" developperView={this.props.developperView} variant="caption">
					{this.props.responseSimulation.vehicleDetails.result.teaser.textConditions.regularPaymentConditions.map((line, index) => (
						<span key={index} style={{ ...Dico.getStyle(line.style, true), fontSize: '10pt' }}>
							{index === 0 && <React.Fragment >{this.renderReferenceAlone()}</React.Fragment >}
							{Dico.getTextWithArguments(line,
								this.props.responseSimulation.vehicleDetails.result.teaser.data,
								this.props.amountNature, this.props.context.countryCode, this.props.context.languageCode,
								this.props.responseSimulation.vehicleDetails.result.teaser.guide)}
							{line.detailOpenText != null &&
								<ContDetailsButton text={line.detailOpenText} detailOpenText='true'
									configurationKey={`${HelperGenerics.rebuildWord(this.props.configurationKey)}_bottom`} />
							}
						</span>
					))}
				</TextWithFieldname>
			}
			{isSingleVehicleBasketSummary && isSingleVehicleTextConditions
				&& this.props.responseSimulation.vehicleDetails.result.teaser.textConditions.primaryTextConditions != null
				&& <TextWithFieldname fieldname="primaryTextConditions" developperView={this.props.developperView} variant="caption">
					{this.getRenderReferenceOccurenceMultipleLines(this.props.responseSimulation.vehicleDetails.result.teaser.textConditions.primaryTextConditions,
						this.props.responseSimulation.vehicleDetails.result)}
				</TextWithFieldname>
			}
			{isSingleVehicleBasketSummary && isSingleVehicleTextConditions
				&& this.props.responseSimulation.vehicleDetails.result.teaser.textConditions.ctaTeaserConditions != null
				&& <TextWithFieldname fieldname="ctaTeaserConditions" developperView={this.props.developperView} variant="caption">
					{this.getRenderReferenceOccurenceMultipleLines(this.props.responseSimulation.vehicleDetails.result.teaser.textConditions.ctaTeaserConditions,
						this.props.responseSimulation.vehicleDetails.result)}
				</TextWithFieldname>
			}
		</React.Fragment>);
	}

	occRenvoiGlob = 1;
	getRenderReferenceOccurenceMultipleLines(lines, mainResult) {
		lines.map(
			(line2, index2) => (
				<React.Fragment key={index2}>
					{this.renderReferenceOccurence(line2, index2, mainResult.teaser)}
				</React.Fragment>
			));
	}

	renderReferenceOccurence(line, index, teaser) {
		return (
			<span style={{ ...Dico.getStyle(line.style, true), fontSize: '10pt' }}>
				{index === 0 && <React.Fragment >{this.renderReferenceAlone()}</React.Fragment >}
				{Dico.getTextWithArguments(line,
					teaser.data,
					this.props.amountNature, this.props.context.countryCode, this.props.context.languageCode,
					teaser.guide)}
			</span>
		);
	}
	renderReferenceAlone() {
		const occRenvoiIni = this.occRenvoiGlob;
		this.occRenvoiGlob++
		return (
			<React.Fragment >({occRenvoiIni}) </React.Fragment >
		)
	}
}

export default (BottomTexts)
